import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './BookWithUs.css';
import bookWithUsImage from '../assets/book-with-us.png';

const BookWithUs = () => {
  const [form, setForm] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    destination: '',
    dates: '',
    wishes: '',
  });
  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const update = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
    if (errors[field]) setErrors({ ...errors, [field]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.client_name.trim()) newErrors.client_name = 'Имя обязательно';
    if (!form.client_email.trim()) {
      newErrors.client_email = 'Email обязателен';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.client_email)) {
      newErrors.client_email = 'Некорректный email';
    }
    if (!form.client_phone.trim()) newErrors.client_phone = 'Телефон обязателен';
    if (!form.destination.trim()) newErrors.destination = 'Укажите направление';
    if (!form.dates.trim()) newErrors.dates = 'Выберите даты';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      const formatted = `${start.toLocaleDateString('ru-RU')} — ${end.toLocaleDateString('ru-RU')}`;
      setForm({ ...form, dates: formatted });
      setTimeout(() => setIsCalendarOpen(false), 100);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setStatus('validation_error');
      return;
    }
    setStatus('pending');
    try {
      const res = await fetch('/api/bookings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Failed to submit booking');
      setStatus('success');
      setForm({ client_name: '', client_email: '', client_phone: '', destination: '', dates: '', wishes: '' });
      setStartDate(null);
      setEndDate(null);
      setErrors({});
    } catch (err) {
      setStatus('error');
      console.error('Ошибка при бронировании:', err);
    }
  };

  const inputClass = (field) => (errors[field] ? 'input-error' : '');

  return (
    <main className="book-with-us">
      <div className="book-with-us-container">
        <h1 className="book-with-us-title">Забронируйте путешествие с нами</h1>
        <p className="book-with-us-subtitle">Поделитесь деталями — мы подберём лучший маршрут.</p>

        <section className="book-form-grid">
          <form onSubmit={submit} className="book-form">
            <label>
              <div>Ваше имя</div>
              <input value={form.client_name} onChange={update('client_name')} type="text" placeholder="Иван Иванов" className={inputClass('client_name')} />
              {errors.client_name && <div className="field-error">{errors.client_name}</div>}
            </label>

            <label>
              <div>Электронная почта</div>
              <input value={form.client_email} onChange={update('client_email')} type="email" placeholder="name@example.com" className={inputClass('client_email')} />
              {errors.client_email && <div className="field-error">{errors.client_email}</div>}
            </label>

            <label>
              <div>Телефон</div>
              <input value={form.client_phone} onChange={update('client_phone')} type="tel" placeholder="+998 00 123 45 67" className={inputClass('client_phone')} />
              {errors.client_phone && <div className="field-error">{errors.client_phone}</div>}
            </label>

            <label>
              <div>Направление</div>
              <input value={form.destination} onChange={update('destination')} type="text" placeholder="Мальдивы, Япония, Италия..." className={inputClass('destination')} />
              {errors.destination && <div className="field-error">{errors.destination}</div>}
            </label>

            <label>
              <div>Даты поездки</div>
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                dateFormat="dd.MM.yyyy"
                placeholderText="Выберите даты"
                className={`date-input ${inputClass('dates')}`}
                onCalendarOpen={() => setIsCalendarOpen(true)}
                onCalendarClose={() => setIsCalendarOpen(false)}
                open={isCalendarOpen}
                onFocus={() => setIsCalendarOpen(true)}
              />
              {errors.dates && <div className="field-error">{errors.dates}</div>}
            </label>

            <label>
              <div>Пожелания</div>
              <textarea value={form.wishes} onChange={update('wishes')} placeholder="Отель 5*, дайвинг, экскурсии..." rows={5} />
            </label>

            <button type="submit" disabled={status === 'pending'}>
              {status === 'pending' ? 'Отправляю...' : 'Отправить запрос'}
            </button>

            {status === 'success' && <div className="form-status success">Заявка отправлена!</div>}
            {status === 'error' && <div className="form-status error">Ошибка отправки.</div>}
          </form>

          <div className="book-form-image">
            <img src={bookWithUsImage} alt="Дорога к путешествию" />
          </div>
        </section>
      </div>
    </main>
  );
};

export default BookWithUs;
